import React from 'react';
import styled from "styled-components";
import cx from "classnames";
import {H2} from '../../components/crousal/Headings';
import {Inertia} from "@inertiajs/inertia";
import {FlashMessage} from "../../components/FlashMessage";

const VerifyEmailBackgroundImage = styled.div`
 background: url('/images/unrankedsmurfs-login/mobile_loginbg.png');
 background-size: cover;

@media (min-width: 1024px) {
  background: url('/images/unrankedsmurfs-login/login_bg.png');
  background-size: cover;
  }
`;

export function VerifyEmail() {
    function sendEmail() {
        Inertia.post('/resend/email/verification-notification');
    }

    return (
        <VerifyEmailBackgroundImage className="h-screen">
            <div className="h-full flex relative">
                <div className={cx('w-full lg:w-3/5 bg-gray-100', 'pt-100 lg:pt-200')}>
                    <div className="w-4/5 xl:w-2/3 mx-auto mt-20">
                        <img src={"/images/unrankedsmurfs-login/login_shield.png"} alt={"shield image"}/>
                        <H2 className="text-36 text-smurfs-gold">Please Verify Your Email Address!</H2>

                        <FlashMessage className="mt-4 w-3/4 xl:w-2/5 p-2 text-md"/>

                        <p className="mt-10">
                            Before proceeding, please check your email for a verification link. If you did not receive
                            the email
                            <div
                                onClick={sendEmail}
                                className="block cursor-pointer font-ubuntu text-smurfs-gold"
                            >
                                click here to request another
                            </div>
                        </p>
                    </div>
                </div>
            </div>
        </VerifyEmailBackgroundImage>
    );
}
